import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import PersonneCard from "./PersonneCard";
import PersonneCardInfo from "./PersonneCardInfo";

const PersonneCardList = (props) => {
  const { personnes, infoView, contributions, allContributions } = props;
  const [tabKey, setTabKey] = useState("informations");

  return (
    <Row className="justify-content-center">
      {personnes.map((personne) =>
        infoView ? (
          <Col style={{ marginTop: 8 }} key={personne._id} xs={12} sm={12} md={12} lg={6}>
            <PersonneCardInfo
              personne={personne}
              tabKey={tabKey}
              setTabKey={setTabKey}
              lastContrib={
                contributions &&
                personne.email !== "" &&
                contributions.filter((contrib) => contrib.email === personne.email)[0]
              }
              lastContribOnAllEspaces={
                allContributions &&
                allContributions.filter((contrib) => contrib.email === personne.email)[0]
              }
            />
          </Col>
        ) : (
          <React.Fragment key={personne._id}>
            <PersonneCard personne={personne} />
          </React.Fragment>
        )
      )}
    </Row>
  );
};

export default PersonneCardList;
